// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1660":"bbb7d9f9","4630":"bbb7d9f9","5378":"edb30248"}[chunkId] + ".chunk.css";
};